import { dbManager } from './db_manager';

export const chatService = {
    async createChat(userId1: string, userId2: string) {
        // Create new ID
        const chatId = crypto.randomUUID();
        await dbManager.execute({ action: 'insert', table: 'chats', data: { id: chatId, user_id: userId1 } });
        await dbManager.execute({ action: 'insert', table: 'chat_participants', data: { chat_id: chatId, user_id: userId1 } });
        await dbManager.execute({ action: 'insert', table: 'chat_participants', data: { chat_id: chatId, user_id: userId2 } });
        return chatId;
    },

    async getUserChats(userId: string) {
        return dbManager.execute({
            action: 'select_public',
            table: 'chat_participants',
            filters: { user_id: userId }
        });
    },

    async getOrCreateChat(user1: string, user2: string) {
        const req1 = await this.getUserChats(user1);
        const req2 = await this.getUserChats(user2);
        
        const chats1 = Array.isArray(req1) ? req1 : req1?.data || [];
        const chats2 = Array.isArray(req2) ? req2 : req2?.data || [];
        
        const shared = chats1.find((c1: any) => chats2.some((c2: any) => c2.chat_id === c1.chat_id));
        if (shared) return shared.chat_id;
        
        return await this.createChat(user1, user2);
    },

    async getMessages(chatId: string) {
        const response = await dbManager.execute({
            action: 'select_public',
            table: 'messages',
            filters: { chat_id: chatId }
        });
        
        // Ensure returning clean array properly sorted depending on how D1 answered it
        const messages = Array.isArray(response) ? response : (response?.data || []);
        return messages.sort((a,b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
    },

    async sendMessage(chatId: string, senderId: string, content: string) {
        const messageId = crypto.randomUUID();
        await dbManager.execute({
            action: 'insert',
            table: 'messages',
            data: {
                id: messageId,
                chat_id: chatId,
                sender_id: senderId,
                content
            }
        });
        
        // Update the last_message_at tracker
        await dbManager.execute({
            action: 'update_filtered',
            table: 'chats',
            filters: { id: chatId },
            data: { last_message_at: new Date().toISOString() }
        });
        
        return messageId;
    },

    async deleteChat(chatId: string) {
        // 1. Delete messages
        await dbManager.execute({
            action: 'delete_filtered',
            table: 'messages',
            filters: { chat_id: chatId }
        });
        
        // 2. Delete participants
        await dbManager.execute({
            action: 'delete_filtered',
            table: 'chat_participants',
            filters: { chat_id: chatId }
        });
        
        // 3. Delete the chat record itself
        await dbManager.execute({
            action: 'delete',
            table: 'chats',
            id: chatId
        });
        
        return { success: true };
    }
};
